import { render, staticRenderFns } from "./groupSelect.vue?vue&type=template&id=05a8bd8a"
import script from "./groupSelect.vue?vue&type=script&lang=js"
export * from "./groupSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports